import Base from "../base.store";
import lodash from "lodash";
import moment from "moment";
import { cacheTime } from "../../../../utils/constant";
import { filter } from "../../../../utils/search";

const baseUrl = "/api/v1/master/departments";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listWithChildren: [],
        listWithChildrenType: {},
        listByParent: {},
        listMain: {},
        cacheDate: {
            listWithChildren: null,
            listWithChildrenType: {},
            listByParent: {},
        }
    }),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cacheFindAll(context, { where, options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const sort = [{ name: "nameTh", type: "ASC" }];
            const list = context.state.list || [];
            if (list?.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAll", { criteria: { select: ["*"] } }).then(list => filter({ list, where, sort }));
        },
        cacheFindAllMain(context, { where, options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listMain;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const sort = [{ name: "nameTh", type: "ASC" }];
            const list = context.state.listMain || [];
            if (list?.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAllMain", { criteria: { select: ["*"] } }).then(list => filter({ list, where, sort }));
        },
        cacheFindAllWithChildren(context, { options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listWithChildren;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const list = context.state.listWithChildren || [];
            if (list?.length > 0 && !force) {
                return list;
            }
            return context.dispatch("findAllWithChildren", {});
        },
        cacheFindAllReceiverDepartment(context, { where= [], options, searchQuery }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listReceiverDepartment;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            if(searchQuery) {
                where.push(
                    { name: "nameTh", type: "String", operator: "like", value: searchQuery },
                    { logic: "OR", name: "nameEn", type: "String", operator: "like", value: searchQuery }
                )
            }
            const sort = [{ name: "nameTh", type: "ASC" }];
            const list = context.state.listReceiverDepartment || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAllReceiverDepartment", { criteria: { select: ["*"] } }).then(list => filter({ list, where, sort }));
        },
        findAllReceiverDepartment(context, { criteria, config }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "isReceiverDepartment", type: "Boolean", operator: "=", value: true },
                    ],
                    sort: [{ name: "nameTh", type: "ASC" }],
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then(page => {
                const list = page.data;
                context.commit("setListReceiverDepartment", { list });
                return list;
            });
        },
        findAllWithChildren(context, { criteria, config }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                    ],
                    sort: [{ name: "nameTh", type: "ASC" }],
                    children: [{ name: "children", select: ["*"], page: 0, size: 1000000, isRecursive: true }]
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then(page => {
                const list = page.data;
                context.commit("setListWithChildren", { list });
                return list;
            });
        },
        findAllMain(context, { criteria, config, type }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refParent.id", type: "UUID", operator: "=", value: null },
                    ],
                    sort: [{ name: "nameTh", type: "ASC" }],
                    //children: [{ name: "children", select: ["*"], page: 0, size: 1000000, isRecursive: true }]
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then(page => {
                const list = page.data;
                context.commit("setListMain", { list, type });
                return list;
            });
        },
        cacheFindAllWithChildrenType(context, { options, type }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listWithChildrenType[type];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const list = context.state.listWithChildrenType[type] || [];
            if (list.length > 0 && !force) {
                return list;
            }
            return context.dispatch("findAllWithChildrenType", { type });
        },
        findAllWithChildrenType(context, { criteria, config, type }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refParent.id", type: "UUID", operator: "=", value: null },
                        { name: "refDepartmentType.key", type: "String", operator: "=", value: type }
                    ],
                    sort: [{ name: "nameTh", type: "ASC" }],
                    children: [{ name: "children", select: ["*"], page: 0, size: 1000000, isRecursive: true }]
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then(page => {
                const list = page.data;
                context.commit("setListWithChildrenType", { list, type });
                return list;
            });
        },
        cacheFindAllByParent(context, { where, parentId, options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listByParent[parentId];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const sort = [{ name: "seq", type: "ASC" }];
            const list = context.state.listByParent[parentId] || [];
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAllByParent", { parentId }).then((list) => filter({ list, where, sort }));
        },
        findAllByParent(context, { criteria, config, parentId }) {
            criteria = lodash.merge(
                {
                    select: ["*", "refParent.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "nameTh", type: "ASC" }],
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refParent.id", type: "UUID", operator: "=", value: parentId },
                    ],
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then((page) => {
                const list = page.data;
                context.commit("setListByParentResult", { parentId, list });
                return list;
            });
        },
    },
    mutations: {
        ...base.mutations,
        setListWithChildren(state, { list }) {
            state.listWithChildren = list;
            state.cacheDate.listWithChildren = moment().add(cacheTime, "ms");
        },
        setListReceiverDepartment(state, { list }) {
            state.listReceiverDepartment = list;
            state.cacheDate.listReceiverDepartment = moment().add(cacheTime, "ms");
        },
        setListWithChildrenType(state, { list, type }) {
            state.listWithChildrenType[type] = list;
            state.cacheDate.listWithChildrenType[type] = moment().add(cacheTime, "ms");
        },
        setListMain(state, { list }) {
            state.listMain = list;
            state.cacheDate.listMain = moment().add(cacheTime, "ms");
        },
        setListByParentResult(state, { parentId, list }) {
            state.listByParent[parentId] = list;
            state.cacheDate.listByParent[parentId] = moment().add(cacheTime, "ms");
        },
    }
};
